import {
  Card,
  Row,
  Col,
  DatePicker,
  Button,
  Input,
  Form,
  Space,
  message,
  Select,
  AutoComplete,
} from "antd";
import { useEffect, useState } from "react";
import { createVisitorDef, VisitorData } from "../../types/visitTypes";
import "./AddVisit.css";
import visitService from "../../services/visitService";
import useAuthorizationData from "../../utils/useAuthorizationData";
import {
  DocumentTypeInfo,
  GenderInfo,
  ShipInfo,
  NationalityInfo,
} from "../../types/visitTypes";
import moment from "moment";

const { Option } = Select;

const AddVisitors = (props: {
  stepNextFunction: any;
  stepBackFunction: any;
  shipId: number | null;
  ships: ShipInfo[];
  startdate: Date | null;
  enddate: Date | null;
  portName: string | null;
  previousVisitors: VisitorData[];
  visitors: VisitorData[];
}) => {
  const [visitors, setVisitors] = useState<VisitorData[]>([
    createVisitorDef(props.visitors === null ? 1 : 0),
  ]);
  const [documentType, setDocumentType] = useState<DocumentTypeInfo[]>([]);
  const [gender, setGender] = useState<GenderInfo[]>([]);
  const [nationality, setNationality] = useState<NationalityInfo[]>([]);
  const [form] = Form.useForm();
  const [previousVisitors, setPreviousVisitors] = useState<VisitorData[]>([]);
  const [authorizationData] = useAuthorizationData();
  const [options, setOptions] = useState<{ label: string; value: string }[]>(
    []
  );
  const errorInfo = (info: string) => {
    message.error(info);
  };

  useEffect(() => {
    fetchData();
    setVisitors(props.visitors);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    const documentTypeInfo = await visitService.GetDocumentTypeList();

    if (documentTypeInfo == null) {
      errorInfo("Fetching document type Failed");
    }
    if (
      documentTypeInfo &&
      documentTypeInfo.data &&
      documentTypeInfo.data.length > 0
    ) {
      const data = documentTypeInfo.data.map(
        (document) =>
          ({
            Key: document.Key,
            Value: document.Value,
          } as DocumentTypeInfo)
      );
      setDocumentType(data);
    }

    const genderInfo = await visitService.GetGenderList();

    if (genderInfo == null) {
      errorInfo("Fetching gender Failed");
    }
    if (genderInfo && genderInfo.data && genderInfo.data.length > 0) {
      const data = genderInfo.data.map(
        (document) =>
          ({
            Key: document.Key,
            Value: document.Value,
          } as GenderInfo)
      );
      setGender(data);
    }

    const nationalityInfo = await visitService.GetNationalityList();

    if (nationalityInfo == null) {
      errorInfo("Fetching nationality Failed");
    }
    if (nationalityInfo && nationalityInfo.data) {
      const data = Object.keys(nationalityInfo.data).map(function (key) {
        return {
          Code: nationalityInfo.data[key].Code,
          Name: nationalityInfo.data[key].Name,
        } as NationalityInfo;
      });

      setNationality(data);
    }

    if (authorizationData !== undefined) {
      const previousVisitorInfo = await visitService.GetVisitList(
        authorizationData.id
      );

      if (previousVisitorInfo == null) {
        errorInfo("Fetching previous visitors Failed");
      }
      if (
        previousVisitorInfo &&
        previousVisitorInfo.data &&
        previousVisitorInfo.data.length > 0
      ) {
        var data: VisitorData[] = [];
        previousVisitorInfo.data.forEach((visitorinfo) =>
          visitorinfo.Visitors.forEach((visitorInfoVisitors) =>
            data.findIndex(
              (visitor) => visitor.FolioId === visitorInfoVisitors.FolioId
            ) === -1
              ? data.push(visitorInfoVisitors)
              : null
          )
        );

        setPreviousVisitors(data);
        const optionsData = data.map((visitor) => ({
          label: visitor.Forename + " " + visitor.Surname,
          value:
            visitor.FolioId.toString() +
            "_" +
            visitor.Forename +
            " " +
            visitor.Surname,
        }));
        setOptions(optionsData);
      }
    }
  };

  const onSelect = (id: number, selectedValue: any) => {
    var endPos = selectedValue.indexOf("_");
    var FolioId = parseInt(selectedValue.substring(0, endPos));
    var prevVisitor = previousVisitors.find((item) => item.FolioId === FolioId);
    if (prevVisitor) {
      fillVisitorFrompPrev(id, prevVisitor);
    }
  };

  function addNewVisitor() {
    var id = Math.max(...visitors.map((item) => item.Id)) + 1;
    setVisitors((oldArray) => [...oldArray, createVisitorDef(id)]);
    //Clear form UI
    form.setFieldsValue({ [id + "_Forename"]: "" });
    form.setFieldsValue({ [id + "_Surname"]: "" });
    form.setFieldsValue({ [id + "_Address"]: "" });
    form.setFieldsValue({ [id + "_Phone"]: "" });
    form.setFieldsValue({ [id + "_City"]: "" });
    form.setFieldsValue({ [id + "_Email"]: "" });
    form.setFieldsValue({ [id + "_TravelerComments"]: "" });
    form.setFieldsValue({ [id + "_ContactPerson"]: "" });
    form.setFieldsValue({ [id + "_LicensePlate"]: "" });
    form.setFieldsValue({ [id + "_VisitorFunction"]: "" });
    form.setFieldsValue({ [id + "_DocumentNumber"]: "" });
    form.setFieldsValue({ [id + "_DocumentForename"]: "" });
    form.setFieldsValue({ [id + "_DocumentSurname"]: "" });
    form.setFieldsValue({ [id + "_DocumentAddress"]: "" });
  }

  function delNewVisitor(id: number) {
    var newVisitors = [...visitors];
    newVisitors.splice(
      newVisitors.findIndex((item) => item.Id === id),
      1
    );
    setVisitors(newVisitors);
  }

  function copyNewVisitorInfo(id: number) {
    var visitorData = visitors.find((item) => item.Id === id);
    if (visitorData) {
      visitorData.DocumentSurname = visitorData.Surname;
      visitorData.DocumentAddress = visitorData.Address;
      visitorData.DocumentForename = visitorData.Forename;
      //Clear FolioId if previously selected
      visitorData.FolioId = 0;
    }

    setVisitors(
      visitors.map((item) =>
        item.Id === id ? (visitorData as VisitorData) : item
      )
    );

    //Update form UI
    form.setFieldsValue({ [id + "_DocumentForename"]: visitorData?.Forename });
    form.setFieldsValue({ [id + "_DocumentSurname"]: visitorData?.Surname });
    form.setFieldsValue({ [id + "_DocumentAddress"]: visitorData?.Address });
  }

  function onTodoChange(value: string, id: number, key: string): void {
    var visitorData = visitors.find((item) => item.Id === id);
    if (visitorData) {
      switch (key) {
        case "Address":
          visitorData.Address = value;
          break;
        case "City":
          visitorData.City = value;
          break;
        case "DocumentAddress":
          visitorData.DocumentAddress = value;
          break;
        case "DocumentForename":
          visitorData.DocumentForename = value;
          break;
        case "DocumentNumber":
          visitorData.DocumentNumber = value;
          break;
        case "DocumentSurname":
          visitorData.DocumentSurname = value;
          break;
        case "Email":
          visitorData.Email = value;
          break;
        case "Forename":
          visitorData.Forename = value;
          break;
        case "Phone":
          visitorData.Phone = value;
          break;
        case "Surname":
          visitorData.Surname = value;
          break;
        case "TravelerComments":
          visitorData.TravelerComments = value;
          break;
        case "ContactPerson":
          visitorData.ContactPerson = value;
          break;
        case "LicensePlate":
          visitorData.LicensePlate = value;
          break;
        case "VisitorFunction":
          visitorData.VisitorFunction = value;
          break;    
      }
      //Clear FolioId if previously selected
      visitorData.FolioId = 0;
      setVisitors(
        visitors.map((item) =>
          item.Id === id ? (visitorData as VisitorData) : item
        )
      );
    }
  }

  function onBirthDateChange(date: any, dateString: string, id: number): void {
    var visitorData = visitors.find((item) => item.Id === id);
    if (visitorData) {
      var localDate = moment(date).toDate();
      visitorData.BirthDate = new Date(
        Date.UTC(
          localDate.getFullYear(),
          localDate.getMonth(),
          localDate.getDate()
        )
      );

      //Clear FolioId if previously selected
      visitorData.FolioId = 0;
      setVisitors(
        visitors.map((item) =>
          item.Id === id ? (visitorData as VisitorData) : item
        )
      );
    }
  }

  function onValidDateChange(date: any, dateString: string, id: number): void {
    var visitorData = visitors.find((item) => item.Id === id);
    if (visitorData) {
      var localDate = moment(date).toDate();
      visitorData.DocumentValidDate = new Date(
        Date.UTC(localDate.getFullYear(), localDate.getMonth())
      );

      //Clear FolioId if previously selected
      visitorData.FolioId = 0;
      setVisitors(
        visitors.map((item) =>
          item.Id === id ? (visitorData as VisitorData) : item
        )
      );
    }
  }

  function handleGenderChange(value: any, id: number) {
    var visitorData = visitors.find((item) => item.Id === id);
    if (visitorData) {
      visitorData.Gender = value;

      //Clear FolioId if previously selected
      visitorData.FolioId = 0;
      setVisitors(
        visitors.map((item) =>
          item.Id === id ? (visitorData as VisitorData) : item
        )
      );
    }
  }

  function handleDocumentTypeChange(value: any, id: number) {
    var visitorData = visitors.find((item) => item.Id === id);
    if (visitorData) {
      visitorData.DocumentType = value;

      //Clear FolioId if previously selected
      visitorData.FolioId = 0;
      setVisitors(
        visitors.map((item) =>
          item.Id === id ? (visitorData as VisitorData) : item
        )
      );
    }
  }

  function handleNationalityChange(value: any, id: number) {
    var visitorData = visitors.find((item) => item.Id === id);
    if (visitorData) {
      visitorData.Nationality = value;

      //Clear FolioId if previously selected
      visitorData.FolioId = 0;
      setVisitors(
        visitors.map((item) =>
          item.Id === id ? (visitorData as VisitorData) : item
        )
      );
    }
  }

  const setVisitorsAddCompleted = () => {
    form.validateFields().then(() => {
      props.stepNextFunction(visitors, gender, documentType, nationality);
    });
  };

  function fillVisitorFrompPrev(id: number, prevVisitor: VisitorData) {
    var visitorData = visitors.find((item) => item.Id === id);
    var preDate = moment(prevVisitor.BirthDate).toDate();
    var preValidDate = moment(prevVisitor.DocumentValidDate).toDate();
    if (visitorData && prevVisitor) {
      visitorData.Forename = prevVisitor.Forename;
      visitorData.Surname = prevVisitor.Surname;
      visitorData.BirthDate = prevVisitor.BirthDate
        ? new Date(
            Date.UTC(
              preDate.getFullYear(),
              preDate.getMonth(),
              preDate.getDate()
            )
          )
        : null;
      handleGenderChange(
        gender.find((gen) => gen.Value === prevVisitor.Gender)?.Key,
        id
      );
      handleNationalityChange(
        nationality.find((gen) => gen.Name === prevVisitor.Nationality)?.Code,
        id
      );
      visitorData.Address = prevVisitor.Address;
      visitorData.Phone = prevVisitor.Phone;
      visitorData.City = prevVisitor.City;
      visitorData.Email = prevVisitor.Email;
      visitorData.TravelerComments = prevVisitor.TravelerComments;
      visitorData.VisitorFunction = prevVisitor.VisitorFunction;
      visitorData.LicensePlate = prevVisitor.LicensePlate;
      visitorData.ContactPerson = prevVisitor.ContactPerson;
      visitorData.DocumentNumber = prevVisitor.DocumentNumber;
      visitorData.DocumentForename = prevVisitor.DocumentForename;
      visitorData.DocumentSurname = prevVisitor.DocumentSurname;
      visitorData.DocumentAddress = prevVisitor.DocumentAddress;
      handleDocumentTypeChange(
        documentType.find((doc) => doc.Value === prevVisitor.DocumentType)?.Key,
        id
      );
      visitorData.DocumentValidDate = prevVisitor.DocumentValidDate
        ? new Date(
            Date.UTC(
              preValidDate.getFullYear(),
              preValidDate.getMonth(),
              preValidDate.getDate()
            )
          )
        : null;
      form.setFieldsValue({ [id + "_Forename"]: prevVisitor.Forename });
      form.setFieldsValue({ [id + "_Surname"]: prevVisitor.Surname });
      form.setFieldsValue({
        [id + "_Birthdate"]: moment(prevVisitor.BirthDate),
      });
      form.setFieldsValue({ [id + "_Gender"]: visitorData.Gender });
      form.setFieldsValue({ [id + "_Address"]: prevVisitor.Address });
      form.setFieldsValue({ [id + "_Phone"]: prevVisitor.Phone });
      form.setFieldsValue({ [id + "_City"]: prevVisitor.City });
      form.setFieldsValue({ [id + "_Email"]: prevVisitor.Email });
      form.setFieldsValue({ [id + "_Nationality"]: prevVisitor.Nationality });
      form.setFieldsValue({
        [id + "_TravelerComments"]: prevVisitor.TravelerComments,
      });
      form.setFieldsValue({
        [id + "_VisitorFunction"]: prevVisitor.VisitorFunction,
      });
      form.setFieldsValue({
        [id + "_LicensePlate"]: prevVisitor.LicensePlate,
      });
      form.setFieldsValue({
        [id + "_ContactPerson"]: prevVisitor.ContactPerson,
      });
      form.setFieldsValue({
        [id + "_DocumentNumber"]: prevVisitor.DocumentNumber,
      });
      form.setFieldsValue({
        [id + "_DocumentForename"]: prevVisitor.DocumentForename,
      });
      form.setFieldsValue({
        [id + "_DocumentSurname"]: prevVisitor.DocumentSurname,
      });
      form.setFieldsValue({
        [id + "_DocumentAddress"]: prevVisitor.DocumentAddress,
      });
      form.setFieldsValue({ [id + "_DocumentType"]: visitorData.DocumentType });
      form.setFieldsValue({
        [id + "_DocumentValidDate"]: moment(visitorData.DocumentValidDate),
      });
      visitorData.FolioId = prevVisitor.FolioId;
    }
    setVisitors(
      visitors.map((item) =>
        item.Id === id ? (visitorData as VisitorData) : item
      )
    );
  }

  return (
    <>
      <div className="add-visit-step-2">
        <Row>
          <Col span={18} offset={3}>
            <Row>
              <Col
                className="add-visit-column"
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={18}
                xxl={18}
              >
                <div className="add-visit-visitors">
                  <Form
                    form={form}
                    name="basic"
                    labelCol={{ span: 10 }}
                    className="visitor-form"
                    layout="vertical"
                  >
                    {visitors.map((visitor) => (
                      <Card
                        key={visitor.Id + "_Step_2_Card"}
                        className="add-visit-visitor"
                      >
                        <span>
                          <h3>
                            {visitors.length > 1
                              ? "Visitor " + visitor.Id
                              : "Visitor data"}
                          </h3>
                        </span>
                        {visitor.Id > 1 ? (
                          <div className="del-visit-new-visitor">
                            <Button onClick={(e) => delNewVisitor(visitor.Id)}>
                              Remove
                            </Button>
                          </div>
                        ) : (
                          ""
                        )}
                        <Row>
                          <Col
                            className="add-visit-visitors-item"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={12}
                            xl={12}
                            xxl={12}
                          >
                            <Form.Item
                              label="First name"
                              name={visitor.Id + "_Forename"}
                              className="form-item"
                              initialValue={visitor?.Forename}
                              rules={[
                                {
                                  required: true,
                                  message: "Please provide your First name!",
                                },
                                {
                                  max: 30,
                                  message: "Value exceeds 30 characters",
                                },
                              ]}
                            >
                              <AutoComplete
                                options={options}
                                onChange={(e) =>
                                  onTodoChange(e, visitor.Id, "Forename")
                                }
                                onSelect={(e: any) => onSelect(visitor.Id, e)}
                                filterOption={(inputValue, option) =>
                                  option!.value
                                    .toUpperCase()
                                    .indexOf(inputValue.toUpperCase()) !== -1
                                }
                              />
                              {/* <Select
                                    onChange={(e) =>
                                      handleVisitorSelect(
                                        e,
                                        visitor.Id,
                                        "Forename"
                                      )
                                    }
                                  >
                                    {previousVisitors.map((prevVisitor) => (
                                      <Option value={prevVisitor.Id} key={prevVisitor.Id}>
                                        {prevVisitor.Forename} {prevVisitor.Surname}
                                      </Option>
                                    ))}
                                  </Select> */}
                            </Form.Item>
                          </Col>
                          <Col
                            className="add-visit-visitors-item"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={12}
                            xl={12}
                            xxl={12}
                          >
                            <Form.Item
                              label="Last name"
                              name={visitor.Id + "_Surname"}
                              className="form-item"
                              initialValue={visitor?.Surname}
                              rules={[
                                {
                                  required: true,
                                  message: "Please provide your Last name!",
                                },
                                {
                                  max: 60,
                                  message: "Value exceeds 60 characters",
                                },
                              ]}
                            >
                              <AutoComplete
                                options={options}
                                onChange={(e) =>
                                  onTodoChange(e, visitor.Id, "Surname")
                                }
                                onSelect={(e: any) => onSelect(visitor.Id, e)}
                              />
                              {/* <Select
                                    onChange={(e) =>
                                      handleVisitorSelect(
                                        e,
                                        visitor.Id,
                                        "Surname"
                                      )
                                    }
                                  >
                                    {previousVisitors.map((prevVisitor) => (
                                      <Option value={prevVisitor.Id} key={prevVisitor.Id}>
                                        {prevVisitor.Forename} {prevVisitor.Surname}
                                      </Option>
                                    ))}
                                  </Select> */}
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            className="add-visit-visitors-item"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={12}
                            xl={12}
                            xxl={12}
                          >
                            <Form.Item
                              label="Birth date"
                              name={visitor.Id + "_Birthdate"}
                              className="form-item"
                              initialValue={
                                visitor?.BirthDate != null
                                  ? moment(visitor.BirthDate)
                                  : null
                              }
                              rules={[
                                {
                                  required: true,
                                  message: "Please provide your Birth date!",
                                },
                                {
                                  validator: (
                                    rule: any,
                                    value: string,
                                    cb: (msg?: string) => void
                                  ) => {
                                    moment(visitor.BirthDate) > moment.utc()
                                      ? cb("Please provide correct birth date!")
                                      : cb();
                                  },
                                },
                              ]}
                            >
                              <DatePicker
                                style={{ width: "100%" }}
                                allowClear={false}
                                onChange={(date, dateString) =>
                                  onBirthDateChange(
                                    date,
                                    dateString,
                                    visitor.Id
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col
                            className="add-visit-visitors-item"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={12}
                            xl={12}
                            xxl={12}
                          >
                            <Form.Item
                              label="Gender"
                              name={visitor.Id + "_Gender"}
                              className="form-item"
                              initialValue={visitor?.Gender}
                            >
                              <Select
                                onChange={(value) =>
                                  handleGenderChange(value, visitor.Id)
                                }
                              >
                                {gender.map((type) => (
                                  <Option value={type.Key} key={type.Key}>
                                    {type.Value}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            className="add-visit-visitors-item"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={12}
                            xl={12}
                            xxl={12}
                          >
                            <Form.Item
                              label="Address"
                              name={visitor.Id + "_Address"}
                              className="form-item"
                              initialValue={visitor?.Address}
                              rules={[
                                {
                                  max: 100,
                                  message: "Value exceeds 100 characters",
                                },
                              ]}
                            >
                              <Input
                                value={visitor?.Address}
                                onChange={(e) =>
                                  onTodoChange(
                                    e.target.value,
                                    visitor.Id,
                                    "Address"
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col
                            className="add-visit-visitors-item"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={12}
                            xl={12}
                            xxl={12}
                          >
                            <Form.Item
                              label="City"
                              name={visitor.Id + "_City"}
                              className="form-item"
                              initialValue={visitor?.City}
                              rules={[
                                {
                                  max: 30,
                                  message: "Value exceeds 30 characters",
                                },
                              ]}
                            >
                              <Input
                                value={visitor?.City}
                                onChange={(e) =>
                                  onTodoChange(
                                    e.target.value,
                                    visitor.Id,
                                    "City"
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            className="add-visit-visitors-item"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={12}
                            xl={12}
                            xxl={12}
                          >
                            <Form.Item
                              label="Email"
                              name={visitor.Id + "_Email"}
                              className="form-item"
                              initialValue={visitor?.Email}
                              rules={[
                                {
                                  required: true,
                                  message: "Please provide your Email!",
                                },
                                {
                                  type: "email",
                                  message: "Please enter a valid Email!",
                                },
                              ]}
                            >
                              <Input
                                value={visitor?.Email}
                                onChange={(e) =>
                                  onTodoChange(
                                    e.target.value,
                                    visitor.Id,
                                    "Email"
                                  )
                                }
                              />
                            </Form.Item>{" "}
                          </Col>
                          <Col
                            className="add-visit-visitors-item"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={12}
                            xl={12}
                            xxl={12}
                          >
                            <Form.Item
                              label="Phone"
                              name={visitor.Id + "_Phone"}
                              className="form-item"
                              initialValue={visitor?.Phone}
                              rules={[
                                {
                                  max: 30,
                                  message: "Value exceeds 30 characters",
                                },
                              ]}
                            >
                              <Input
                                value={visitor?.Phone}
                                onChange={(e) =>
                                  onTodoChange(
                                    e.target.value,
                                    visitor.Id,
                                    "Phone"
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            className="add-visit-visitors-item"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={12}
                            xl={12}
                            xxl={12}
                          >
                            <Form.Item
                              label="Nationality"
                              name={visitor.Id + "_Nationality"}
                              className="form-item"
                              initialValue={visitor?.Nationality}
                              rules={[
                                {
                                  required: true,
                                  message: "Please provide your Nationality!",
                                },
                              ]}
                            >
                              <Select
                                onChange={(value) =>
                                  handleNationalityChange(value, visitor.Id)
                                }
                              >
                                {nationality.map((type) => (
                                  <Option value={type.Code} key={type.Code}>
                                    {type.Name}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col
                            className="add-visit-visitors-item"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={12}
                            xl={12}
                            xxl={12}
                          >
                            <Form.Item
                              label="Company name"
                              name={visitor.Id + "_TravelerComments"}
                              className="form-item"
                              initialValue={visitor?.TravelerComments}
                              rules={[
                                {
                                  max: 200,
                                  message: "Value exceeds 200 characters",
                                },
                                {
                                  required: true,
                                  message: "Please provide your Company name!",
                                },
                              ]}
                            >
                              <Input
                                value={visitor?.TravelerComments}
                                onChange={(e) =>
                                  onTodoChange(
                                    e.target.value,
                                    visitor.Id,
                                    "TravelerComments"
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            className="add-visit-visitors-item"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={12}
                            xl={12}
                            xxl={12}
                          >
                            <Form.Item
                              label="Function"
                              name={visitor.Id + "_VisitorFunction"}
                              className="form-item"
                              initialValue={visitor?.VisitorFunction}
                              rules={[
                                {
                                  max: 50,
                                  message: "Value exceeds 50 characters",
                                },
                              ]}
                            >
                              <Input
                                onChange={(e) =>
                                  onTodoChange(
                                    e.target.value,
                                    visitor.Id,
                                    "VisitorFunction"
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col
                            className="add-visit-visitors-item"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={12}
                            xl={12}
                            xxl={12}
                          >
                            <Form.Item
                              label="Contact on board"
                              name={visitor.Id + "_ContactPerson"}
                              className="form-item"
                              initialValue={visitor?.ContactPerson}
                              rules={[
                                {
                                  max: 50,
                                  message: "Value exceeds 50 characters",
                                },
                              ]}
                            >
                              <Input
                                onChange={(e) =>
                                  onTodoChange(
                                    e.target.value,
                                    visitor.Id,
                                    "ContactPerson"
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                        <Col
                            className="add-visit-visitors-item"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={12}
                            xl={12}
                            xxl={12}
                          >
                            <Form.Item
                              label="License plate"
                              name={visitor.Id + "_LicensePlate"}
                              className="form-item"
                              initialValue={visitor?.LicensePlate}
                              rules={[
                                {
                                  max: 50,
                                  message: "Value exceeds 50 characters",
                                },
                              ]}
                            >
                              <Input
                                onChange={(e) =>
                                  onTodoChange(
                                    e.target.value,
                                    visitor.Id,
                                    "LicensePlate"
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <span>
                          <h3>ID data</h3>
                        </span>
                        <div className="copy-visit-new-visitor">
                          <Button
                            onClick={(e) => copyNewVisitorInfo(visitor.Id)}
                          >
                            Copy info
                          </Button>
                        </div>
                        <Row>
                          <Col
                            className="add-visit-visitors-item"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={12}
                            xl={12}
                            xxl={12}
                          >
                            <Form.Item
                              label="Document type"
                              name={visitor.Id + "_DocumentType"}
                              className="form-item"
                              initialValue={visitor?.DocumentType}
                              rules={[
                                {
                                  required: true,
                                  message: "Please provide your Document type!",
                                },
                              ]}
                            >
                              <Select
                                onChange={(value) =>
                                  handleDocumentTypeChange(value, visitor.Id)
                                }
                              >
                                {documentType.map((type) => (
                                  <Option value={type.Key} key={type.Key}>
                                    {type.Value}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>{" "}
                          </Col>
                          <Col
                            className="add-visit-visitors-item"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={12}
                            xl={12}
                            xxl={12}
                          >
                            <Form.Item
                              label="Document number"
                              name={visitor.Id + "_DocumentNumber"}
                              className="form-item"
                              initialValue={visitor?.DocumentNumber}
                              rules={[
                                {
                                  required: true,
                                  message:
                                    "Please provide your Document number!",
                                },
                                {
                                  max: 20,
                                  message: "Value exceeds 20 characters",
                                },
                              ]}
                            >
                              <Input
                                value={visitor?.DocumentNumber}
                                onChange={(e) =>
                                  onTodoChange(
                                    e.target.value,
                                    visitor.Id,
                                    "DocumentNumber"
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            className="add-visit-visitors-item"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={12}
                            xl={12}
                            xxl={12}
                          >
                            <Form.Item
                              label="First name"
                              name={visitor.Id + "_DocumentForename"}
                              className="form-item"
                              initialValue={visitor?.DocumentForename}
                              rules={[
                                {
                                  required: true,
                                  message: "Please provide your First name!",
                                },
                                {
                                  max: 30,
                                  message: "Value exceeds 30 characters",
                                },
                              ]}
                            >
                              <Input
                                onChange={(e) =>
                                  onTodoChange(
                                    e.target.value,
                                    visitor.Id,
                                    "DocumentForename"
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col
                            className="add-visit-visitors-item"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={12}
                            xl={12}
                            xxl={12}
                          >
                            <Form.Item
                              label="Last name"
                              name={visitor.Id + "_DocumentSurname"}
                              className="form-item"
                              initialValue={visitor?.DocumentSurname}
                              rules={[
                                {
                                  required: true,
                                  message: "Please provide your Last name!",
                                },
                                {
                                  max: 60,
                                  message: "Value exceeds 60 characters",
                                },
                              ]}
                            >
                              <Input
                                onChange={(e) =>
                                  onTodoChange(
                                    e.target.value,
                                    visitor.Id,
                                    "DocumentSurname"
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            className="add-visit-visitors-item"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={12}
                            xl={12}
                            xxl={12}
                          >
                            <Form.Item
                              label="Place"
                              name={visitor.Id + "_DocumentAddress"}
                              className="form-item"
                              initialValue={visitor?.DocumentAddress}
                              rules={[
                                {
                                  max: 50,
                                  message: "Value exceeds 50 characters",
                                },
                              ]}
                            >
                              <Input
                                onChange={(e) =>
                                  onTodoChange(
                                    e.target.value,
                                    visitor.Id,
                                    "DocumentAddress"
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col
                            className="add-visit-visitors-item"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={12}
                            xl={12}
                            xxl={12}
                          >
                            <Form.Item
                              label="Valid date"
                              name={visitor.Id + "_DocumentValidDate"}
                              className="form-item"
                              initialValue={
                                visitor?.DocumentValidDate != null
                                  ? moment(visitor.DocumentValidDate)
                                  : null
                              }
                              rules={[
                                {
                                  required: true,
                                  message: "Please provide your Valid date!",
                                },
                                {
                                  validator: (
                                    rule: any,
                                    value: string,
                                    cb: (msg?: string) => void
                                  ) => {
                                    moment(visitor.DocumentValidDate) <
                                    moment.utc()
                                      ? cb("Please provide correct valid date!")
                                      : cb();
                                  },
                                },
                              ]}
                            >
                              <DatePicker
                                style={{ width: "100%" }}
                                allowClear={false}
                                picker="month"
                                onChange={(date, dateString) =>
                                  onValidDateChange(
                                    date,
                                    dateString,
                                    visitor.Id
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Card>
                    ))}
                  </Form>
                </div>
                <div className="add-visit-new-visitor">
                  <Button onClick={addNewVisitor}>Add another person</Button>
                </div>
              </Col>
              <Col
                className="add-visit-column"
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={6}
                xxl={6}
              >
                <div className="add-visit-summary">
                  <span>
                    <h3>Summary</h3>
                  </span>

                  <Card>
                    Ship:{" "}
                    {props.shipId != null
                      ? props.ships.find((ship) => ship.Id === props.shipId)
                          ?.Name
                      : "-"}
                    <br />
                    Date:{" "}
                    {props.startdate != null && props.enddate != null
                      ? props.startdate?.toLocaleDateString() +
                        " - " +
                        props.enddate?.toLocaleDateString()
                      : "-"}
                    <br />
                    Port: {props.portName != null ? props.portName : "-"}
                    <br />
                    <br />
                    Visitors:
                    <br />
                    {visitors.map((visitor) => (
                      <div
                        className="add-visit-summary-text-value"
                        key={visitor.Id + "Summary"}
                      >
                        {visitor.Forename} {visitor.Surname}{" "}
                        {visitor.FolioId > 0
                          ? "(existing folio)"
                          : "(new folio)"}
                      </div>
                    ))}
                  </Card>
                </div>
                <div className="add-visit-next-step">
                  <Space direction="horizontal">
                    <Button onClick={props.stepBackFunction}>Back</Button>
                    <Button onClick={setVisitorsAddCompleted}>Next step</Button>
                  </Space>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AddVisitors;
